import { render, staticRenderFns } from "./paymentmethod.vue?vue&type=template&id=45a7be8d&scoped=true&"
import script from "./paymentmethod.vue?vue&type=script&lang=js&"
export * from "./paymentmethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7be8d",
  null
  
)

export default component.exports